// extracted by mini-css-extract-plugin
export var card = "card-module--card--7758c";
export var cardContent = "card-module--cardContent--5d61c";
export var chapo = "card-module--chapo--58581";
export var date = "card-module--date--f9ccd";
export var title = "card-module--title--dc63e";